import { render, staticRenderFns } from "./WeserveSideBar.vue?vue&type=template&id=7c807741"
import script from "./WeserveSideBar.vue?vue&type=script&lang=js"
export * from "./WeserveSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports